import { render, staticRenderFns } from "./flat-cards-kohota.vue?vue&type=template&id=07275cbc&scoped=true&"
import script from "./flat-cards-kohota.vue?vue&type=script&lang=js&"
export * from "./flat-cards-kohota.vue?vue&type=script&lang=js&"
import style0 from "./flat-cards-kohota.vue?vue&type=style&index=0&id=07275cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07275cbc",
  null
  
)

export default component.exports